import Vue from 'vue'
import VueI18n from 'vue-i18n'
import cn from './langFile/cn.json'
import en from './langFile/en.json'

const locale = 'zh';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale,
  messages: {
    'zh': cn,
    'en': en
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/lang/lang.js